import React from "react";
import {Text as DefaultText, StyleSheet} from 'react-native';

export type TextProps = DefaultText['props'];

const Text: React.VFC<TextProps> = ({ style, ...otherProps }) => {
    return (
        <DefaultText style={[styles.text, style]} {...otherProps}  />
    );
};

const styles = StyleSheet.create({
    text: {
        fontFamily: "Urbanist_Medium",
        fontSize: 16,
        color: "#ffffff",
        textAlign: "center",
        lineHeight: 29,
    }
});

export default Text;